import React from "react"
import {Table} from "antd"

export const OrganizationLDAPTable: React.FC = (): React.ReactElement => {
  const ldapServers = [
    { id: "1234", name: "Main LDAP Server" },
    { id: "1235", name: "Development LDAP Server" }
  ]

  const columns = [
    { title: "ID", dataIndex: "id" },
    { title: "Name", dataIndex: "name" }
  ]
  return <Table dataSource={ldapServers} columns={columns}/>
}